import { useLayoutEffect, useState } from "react";

const App = () => {
  const [urlError, setUrlError] = useState(null);

  const validUrl = (url) =>
    url.includes("hangfire") ||
    url.includes("webapi") ||
    url.includes("connector") ||
    url.includes("robovalor");

  const handleRedirect = () => {
    const appUrl = window.origin || "";

    const splittedUrl = appUrl.split(".");

    const hasError = splittedUrl?.length !== 3;

    if (hasError) setUrlError(appUrl);
    else {
      const pathname = window.location.pathname;
      const search = window.location.search;

      const newUrl = validUrl(appUrl)
        ? appUrl
        : `${splittedUrl[0]}.${splittedUrl[1]}.net${pathname}${search}`;
      window.location.href = newUrl;
    }
  };

  useLayoutEffect(() => {
    handleRedirect();
  }, []);

  const renderError = () => (
    <div className="page">
      <div className="container">
        <img src="/logo.png" alt="Actio Logo" className="logo" />
        <h1 className="title">
          Actio <span>Software</span>
        </h1>
        <p className="description">
          This url is not valid or could not be found:
        </p>
        <div className="code">{urlError}</div>
        <div className="website-link">
          <a
            href="https:www.actiosoftware.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Check our website
          </a>
        </div>
        <div className="footer">@ Actio Software - Redirect App.</div>
      </div>
    </div>
  );

  return urlError ? renderError() : "";
};

export default App;
